import styled from 'styled-components';

export const Maintitle = styled.h1`
    margin: 0 auto;
    font-size: 24px;
    color: ${({theme}) => theme.palette.secondary.main};
`